enum IncomingPayloadEvent {
  // Error
  V1_ERROR = "v1_error",

  // Other
  V1_GOT_RESTAURANT_CATEGORIES = "v1_got_restaurant_categories",

  // User
  V1_USER_GUEST_LOGGED_IN = "v1_user_guest_logged_in",
  V1_USER_GOT = "v1_user_got",

  // Group
  V1_GROUP_CREATED = "v1_group_created",
  V1_GROUP_JOINED = "v1_group_joined",
  V1_GROUP_READIED = "v1_group_readied",
  V1_GROUP_RESTAURANT_CATEGORIES_CHOSEN = "v1_group_restaurant_categories_chosen",
  V1_GROUP_TOP_RESTAURANTS = "v1_group_top_restaurants",
  V1_GROUP_RESTAURANTS_CHOSEN = "v1_group_restaurants_chosen",
  V1_GROUP_FINAL_RESULT = "v1_group_final_result",
}

export default IncomingPayloadEvent;
